import { useCallback, useMemo } from 'react'

import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackClientEvent } from 'analytics/analytics'
import uuidV4 from 'lib/string/uuidV4Utils'

export const EXPERIENCES_HOMEPAGE_UPLIFT_TRACKING_CATEGORY = 'experiences_homepage_uplift'

export type ExperiencesHomepageUpliftTrackingSubject =
  | 'booking_personalisation'
  | 'suggested_searches'
  | 'suggested_searches_global'
  | 'suggested_searches_experience'
  | 'luxplus_top_offers'
  | 'browse_by_category'
  | 'browse_by_trend'
  | 'discover_near'

export type ExperiencesHomepageUpliftTrackingSection =
  | ExperiencesHomepageUpliftTrackingSubject
  | 'top_picks'

export type ExperiencesHomepageUpliftTrackingAction =
  | 'impression'
  | 'explore_now_clicked'
  | 'tile_clicked'
  | 'tile_dismissed'
  | 'clear_all_clicked'
  | 'tab_selected'
  | 'date_filter_selected'
  | 'view_all_clicked'

export function getExperiencesHomepageUpliftListName(
  section: ExperiencesHomepageUpliftTrackingSection,
): string {
  return `${EXPERIENCES_HOMEPAGE_UPLIFT_TRACKING_CATEGORY}_${section}`
}

export function trackExperiencesHomepageUpliftInteraction(
  subject: ExperiencesHomepageUpliftTrackingSubject,
  action: ExperiencesHomepageUpliftTrackingAction,
  section: ExperiencesHomepageUpliftTrackingSection,
  listInstance: string,
  itemPosition?: number,
) {
  const listItem = itemPosition !== undefined && itemPosition >= 1
    ? comluxgroup.createListItem_1_0_0({
        listName: getExperiencesHomepageUpliftListName(section),
        listInstance,
        itemPosition,
      })
    : undefined

  trackClientEvent({
    category: EXPERIENCES_HOMEPAGE_UPLIFT_TRACKING_CATEGORY,
    type: 'interaction',
    subject,
    action,
    ...(listItem && { context: [listItem] }),
  })
}

export function useExperiencesHomepageUpliftTracking(
  section: ExperiencesHomepageUpliftTrackingSection,
) {
  const listInstance = useMemo(() => uuidV4(), [])

  return useCallback((
    subject: ExperiencesHomepageUpliftTrackingSubject,
    action: ExperiencesHomepageUpliftTrackingAction,
    itemPosition?: number,
  ) => {
    trackExperiencesHomepageUpliftInteraction(subject, action, section, listInstance, itemPosition)
  }, [listInstance, section])
}
